import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

/**
 * Theme Ant Design — Design System Clouder
 * Conforme à Cleo_ERP_Charte_Graphique_v2.md §10.1
 */
const CLEO_THEME = {
  token: {
    colorPrimary: '#10B981',
    colorInfo: '#10B981',
    colorSuccess: '#10B981',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',
    borderRadius: 8,
    colorBgLayout: '#F8FAFC',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
  },
  components: {
    Button: {
      colorPrimary: '#10B981',
      algorithm: true,
    },
    Input: {
      activeBorderColor: '#10B981',
      hoverBorderColor: '#10B981',
    },
    Select: {
      colorPrimary: '#10B981',
    },
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider theme={CLEO_THEME} locale={frFR}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>
);
